import HttpUtil from "../util/HttpUtil";
import { showGlobalLoaderType, hideGlobalLoaderType } from './NavMenu';

export const fetchUsersDataType = "FETCH_TELEGRAM_USERS_DATA";
export const clearUsersGridType = "CLEAR_TELEGRAM_USERS_DATA";
export const addUserType = 'ADD_TG_USER';
export const editUserType = 'EDIT_TG_USER';
export const deleteUserType = 'DELETE_TG_USER';


const initialState = {
    users: null,
    isLoading: true
};

export const actionCreators = {
    showGlobalLoader: () => ({ type: showGlobalLoaderType }),
    hideGlobalLoader: () => ({ type: hideGlobalLoaderType }),
    fetch: () => async (dispatch, getState) => {
        dispatch({ type: showGlobalLoaderType });
        HttpUtil.fetchGet("api/TelegramUsers", null, true,
            data => {
                console.log(data);
                dispatch({ type: fetchUsersDataType, users: data });

            }
        );
        dispatch({ type: hideGlobalLoaderType });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;


    if (action.type === clearUsersGridType) {
        return {
            ...state,
            users: null,
            isLoading: true
        }
    }

    if (action.type === fetchUsersDataType) {
        return {
            ...state,
            users: action.users,
            isLoading: false,
        };
        
    }

    if (action.type === addUserType) {
        if (state.users === null) {
            return state;
        }
        var user = action.fields;
        

        user.createDate = new Date().toISOString();
        user.status = "Активен";

        return {
            ...state,
            users: [...state.users, user]
        };
    }

    if (action.type === editUserType) {
        if (state.users === null) {
            return state;
        }

        let users = state.users.map(n => {
            if (n.id === action.fields.id) {
                return {
                    ...n,
                    ...action.fields,
                    client: action.client
                };
            }
            return n;
        });

        return {
            ...state,
            users
        };
    }

    if (action.type === deleteUserType) {
        let users = [...state.users];
        users = users.filter(u => u.id !== action.id);

        return {
            ...state,
            users
        };
    }

    return state;
};
